import Vue from "vue"
import EvercamUI from "@evercam/ui"

Vue.use(EvercamUI)
